// src/49/49_utils.js

export function formatIntegerWithCommas(num) {
    if (num === undefined || num === null || isNaN(num)) return "N/A";
    return Number(num).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function formatLastPrice(val) {
    if (val === undefined || val === null || isNaN(val)) return "N/A";
    const n = Number(val);
    if (n % 1 === 0) return n.toFixed(0);
    const str = n.toFixed(2);
    if (str.endsWith("00")) return n.toFixed(0);
    if (str.endsWith("0")) return n.toFixed(1);
    return str;
}

export function formatRiskAbbreviated(num) {
    if (num === undefined || num === null || isNaN(num)) return "N/A";
    num = Math.floor(num);
    if (num >= 1e6) return (num / 1e6).toFixed(0) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(0) + "K";
    return num.toString();
}

export function formatVolume(num) {
    if (num === undefined || num === null || isNaN(num)) return "N/A";
    num = Number(num);
    if (num >= 1e6) return (num / 1e6).toFixed(1) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1) + "K";
    return num.toString();
}

export function parseCurrencyInput(value) {
    return value.replace(/[$,]/g, "");
}

export function parseSymbols(input) {
    return input
        .split(",")
        .map(s => s.trim().toUpperCase())
        .filter(s => s.length > 0)
        .join(",");
}